const e = {
  name: "Tokyo",
  dimensions: { width: 24, height: 24 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M4.3,0H0v8h2v1H0v2h2v1H0v12h6V12H4v-1h16v1h-2v12h6V12h-2v-1h2V9h-2V8h2V0h-4.3l-0.3,0.2
			C15,3.5,9,3.5,4.6,0.2L4.3,0z M22,6H2V2h1.7c5,3.6,11.7,3.6,16.7,0H22V6z M13,8h7v1h-7V8z M11,8v1H4V8H11z M20,22v-8h2v8H20z
			 M4,14v8H2v-8H4z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as Tokyo
};
